import toastr from 'toastr'
import layout from 'layouts/default'
import placesAutocomplete from 'components/placesAutocomplete'
// import tipTap from 'components/tipTap'
import googleMapsMovableMarker from 'components/googleMapsMovableMarker'
import tabs from '../tabs'
import {dateTime} from 'services'
import { hasPermits } from 'directives'
import { permits } from 'services'
import shuttleSchedule from './shuttleSchedule'
import integrationSystemAttributes from './integrationSystemAttributes'
import switchBtn from 'components/switchBtn'
import timepicker from 'components/timepicker'
import sSelect from 'components/sSelect'
import moment from 'moment'
import { user, helper} from 'services'
import { dateFormat } from 'filters'
// import './details.scss'

const directives = {
  hasPermits
}

const filters = {
  dateFormat,
}

const components = {
  layout,
  tabs,
  placesAutocomplete,
  googleMapsMovableMarker,
  shuttleSchedule,
  integrationSystemAttributes,
  switchBtn,
  timepicker,
  sSelect,
  tipTap: () => import('components/tipTap'),
}

const computed = {
  location () {
    return this.$store.state.locations.active;
  },
  countries () {
    return [{name: "Select Country", id: null}].concat(this.$store.state.address.countries);
  },
  states () {
    let states = [{name: "Select State", id: null}];
    if (this.form.country_id) {

      let indx = _.findIndex(this.countries, item => item.id == this.form.country_id);
      if (indx > -1) {
        states = states.concat(this.countries[indx].states);
      }
    }
    console.log(states);
    return states;
  },
  timezones () {
    return [{name: "Select Timezone", id: null}].concat(this.$store.state.timezones.all);
  },
  parkingIntegrationSystems () {
    return (this.location && this.location.parking_integration_systems) || [];
  },
  roomIntegrationSystems () {
    return (this.location && this.location.room_integration_systems) || [];
  },
  parkingAttributeDefinitions () {
    const system = this.integrationSystemFor('parking');
    return (system && system.attributes) || [];
  },
  roomAttributeDefinitions () {
    const system = this.integrationSystemFor('room');
    return (system && system.attributes) || [];
  },
  pgDisplayName () {
    const settings = this.$store.state.settings.general_settings;
  
    if (Array.isArray(settings)) {
      const item = settings.find(s => s.key === 'parkguard_display_name');
      return item && !_.isEmpty(item.value) ? item.value : 'Vehicle Protection';
    }
  
    return 'Vehicle Protection';
  },
  portCodeOptions () {
    return [{value: null, text: '-- Select Port Code --'}].concat(
      _.map(this.airports, (airport) => {
        return {
          value: airport.iata_code,
          text: airport.iata_code
        };
      })
    );
  },
  portNameOptions () {
    return [{value: null, text: '-- Select Port Name --'}].concat(
      _.map(this.airports, (airport) => {
        return {
          value: airport.airport_name,
          text: airport.airport_name
        };
      })
    );
  },
  selectedPortCode () {
    return this.selectedPortOption(this.portCodeOptions, this.form.port_code);
  },
  selectedPortName () {
    return this.selectedPortOption(this.portNameOptions, this.form.port_name);
  },
  center () {
    if (this.googlePlace) {
      let location = {
        lat: this.googlePlace.geometry.location.lat(),
        lng: this.googlePlace.geometry.location.lng()
      };
      this.form.latitude = this.googlePlace.geometry.location.lat();
      this.form.longitude = this.googlePlace.geometry.location.lng();
      this.googlePlace = null;
      return location;
    } else if (this.form.latitude && this.form.longitude) {
      let location = {
        lat: parseFloat(this.form.latitude),
        lng: parseFloat(this.form.longitude)
      };
      return location;
    }

    return null
  }
}

const methods = {
  onLocationChanged (location) {
    this.form.latitude = location.lat;
    this.form.longitude = location.lng;
  },

  hasShuttleSchedulePermits() {
    return permits.hasLocationPermits(this.locId,['location_shuttle_schedule_update']);
  },

  // shows already saved values that have no matching airport in the list
  selectedPortOption (options, value) {
    if (value === null || typeof value === 'undefined' || value === '') {
      return {};
    }
    return _.find(options, option => option.value === value) || {value, text: value};
  },

  setPortCode (option) {
    this.$set(this.form, 'port_code', option && option.value ? option.value : null);
  },

  setPortName (option) {
    this.$set(this.form, 'port_name', option && option.value ? option.value : null);
  },

  defaultPortCodeType (portType) {
    if (portType === 'airport') {
      return 'iata';
    }
    if (portType === 'seaport') {
      return 'unlocode';
    }
    return null;
  },

  applyDefaultPortCodeType () {
    if (!this.portCodeTypeAutoReady) {
      return;
    }
    const portCodeType = this.defaultPortCodeType(this.form.port_type);
    if (portCodeType) {
      this.$set(this.form, 'port_code_type', portCodeType);
    }
  },

  findAirportBy (field, value) {
    const key = String(value || '').trim().toLowerCase();
    if (!key) {
      return null;
    }
    return _.find(this.airports, (airport) => {
      return String(airport[field] || '').trim().toLowerCase() === key;
    }) || null;
  },

  // fills the counterpart field once the value matches a known airport
  syncPortFields (matchField, airportField, formField, value) {
    if (!this.portAutoFillReady || this.syncingPortFields) {
      return;
    }

    const airport = this.findAirportBy(matchField, value);
    if (!airport || !airport[airportField] || this.form[formField] === airport[airportField]) {
      return;
    }

    this.syncingPortFields = true;
    this.$set(this.form, formField, airport[airportField]);
    this.$nextTick(() => {
      this.syncingPortFields = false;
    });
  },

  fetchAirports () {
    return this.$store.dispatch('dashboards.getAirports').then(() => {
      const data = _.cloneDeep(this.$store.state.dashboards.airports);
      if (Array.isArray(data)) {
        this.airports = data;
      } else if (data && Array.isArray(data.airports)) {
        this.airports = data.airports;
      } else if (data && Array.isArray(data.data)) {
        this.airports = data.data;
      } else {
        this.airports = [];
      }
    }).catch(() => {
      this.airports = [];
    });
  },

  async submit () {
    this.errors = {}
    this.processing = true;
    
    // execute random command to force change event to run
    // this.$refs.description.execCommand('refresh');
    // this.$refs.special_conditions.execCommand('refresh');
    // if (!this.form.shuttle_schedule.length) {
    //   this.$refs.shuttle_info_summary.execCommand('refresh');
    // }
    // this.$refs.shuttle_info_details.execCommand('refresh');

    await this.$store.dispatch('locations.get', {id: this.$route.params.id}).then(() => {      
      this.db_location_data = this.$store.state.locations.active;
    });

    if (!helper.validateChanges(this.keys, this.form, this.initiate_location_data, this.db_location_data)) {
      toastr.error("someone else is making changes to this page, please copy your changes, refresh and do it again.");
      this.processing = false;
      return;
    }

    let data = _.cloneDeep(this.form);
    if (this.published) {
      if (data.published_at == null) {
        data.published_at = moment().format('YYYY-MM-DD HH:mm:ss');
      }
    } else {
      data.published_at = null;
    } 
    delete data.channels;
    delete data.parking_integration_systems;
    delete data.room_integration_systems;
    // data.country_id = this.country;
    // data.state_id = this.state;

    this.$store.dispatch('locations.edit', {id: this.$route.params.id, data}).then(() => {
      this.processing = false;
      if (this.$store.state.locations.errors) {
        this.errors = _.cloneDeep(this.$store.state.locations.errors.errors);
        toastr.error(this.$store.state.locations.errors.message);
      } else {
        toastr.success('Data has been saved');
        this.form.shuttle_info_summary_readable_text = this.$store.state.locations.active.shuttle_info_summary_readable_text;
        this.form.published_at = this.$store.state.locations.active.published_at;
        this.need_to_save = false;
        this.initiate_location_data = _.cloneDeep(this.$store.state.locations.active);
      }
    })
  },

  integrationSystemFor (type) {
    const name = type === 'room'
      ? this.form.rooms_integration_system
      : this.form.integration_system;
    const systems = type === 'room'
      ? this.roomIntegrationSystems
      : this.parkingIntegrationSystems;
    return _.find(systems, system => system.name === name);
  },

  integrationSystemChanged (type) {
    const systemField = type === 'room' ? 'rooms_integration_system' : 'integration_system';
    const attributesField = type === 'room'
      ? 'rooms_integration_system_attributes'
      : 'integration_system_attributes';
    const cache = this.integration_attributes_cache[type];
    const previousName = this.previous_integration_systems[type];
    const name = this.form[systemField];

    if (previousName && previousName !== name) {
      this.$set(cache, previousName, _.cloneDeep(this.form[attributesField] || []));
    }
    this.previous_integration_systems[type] = name;

    if (!name) {
      this.$set(this.form, attributesField, []);
      return;
    }

    const system = this.integrationSystemFor(type);
    // Keep legacy labels intact until the matching system has been migrated.
    if (!system) return;

    const current = cache[name] || this.form[attributesField] || [];
    const attributes = _.map(system.attributes || [], definition => {
      const existing = _.find(current, attribute => attribute.key === definition.key);
      return {
        key: definition.key,
        value: existing && existing.value != null ? existing.value : ''
      };
    });
    this.$set(this.form, attributesField, attributes);
  },
}

export default {
  name: "location-information-details",
  computed,
  components,
  methods,
  directives,
  filters,
  data () {
    return {
      locId: this.$route.params.id,
      loading: false,
      form: {},
      errors: {},
      published: false,
      // timezones: [],
      // country: null,
      // state: null,
      googlePlace: null,
      processing: false,
      integration_attributes_cache: {parking: {}, room: {}},
      previous_integration_systems: {parking: null, room: null},
      user: null,
      times: dateTime.getHalfHours(),
      keys: [
        'name', 'id', 'phone', 'fax', 'send_fax', 'country_id', 'state_id', 'city', 'port_type', 'port_code', 'port_name', 'timezone_id', 'rooms_integration_system_attributes',
        'address', 'zip_code', 'directions', 'send_special_instructions_email', 'number_of_days_before_reservation_starts',
        'special_instructions', 'checkin_time', 'checkout_time', 'extend_reservation_when_check_out', 'auto_checkin_out_enabled', 'tripadvisor_id', 'port_code_type',
        'netpark_code', 'use_netpark_price', 'use_vehicle_protection', 'rooms_integration_system', 'integration_system', 'integration_system_attributes', 'front_desk_hours',
        'daily_email_time', 'description', 'special_conditions', 'shuttle_available', 'free_shuttle', 'shuttle_info_summary',
        'shuttle_schedule', 'type', 'shuttle_info_summary_readable_text', 'shuttle_info_details', 'exclude_bookings_outside_of_shuttle_hours',
        'latitude', 'longitude', 'qr_code_format'
      ],
      initiate_location_data: {},
      db_location_data: {},
      airports: [],
      portCodeTypeAutoReady: false,
      portAutoFillReady: false,
      roomsIntegrationTypeSyncReady: false,
      syncingPortFields: false,
    }
  },
  watch: {
    'form.port_type' () {
      this.applyDefaultPortCodeType();
    },
    'form.port_code' (value) {
      this.syncPortFields('iata_code', 'airport_name', 'port_name', value);
    },
    'form.port_name' (value) {
      this.syncPortFields('airport_name', 'iata_code', 'port_code', value);
    },
    'form.rooms_integration_system' (value) {
      if (!this.roomsIntegrationTypeSyncReady) {
        return;
      }
      const hasRoomsIntegration = Boolean(value && String(value).trim());
      this.$set(this.form, 'type', hasRoomsIntegration ? 'parking_room' : 'parking');
    },
  },
  mounted () {
    this.user = user.getUser();
  },
  created () {
    this.loading = true;
    Promise.all([
      this.$store.dispatch('locations.get', {id: this.$route.params.id}),
      this.$store.dispatch('address.getCountries'),
      this.$store.dispatch('timezones.getAll'),
      this.$store.dispatch('settings.getGeneralSettings'),
      this.fetchAirports()
    ]).then(() => {
      this.loading = false;
      // the port keys must exist on assignment, otherwise Vue can't track them
      // and the port type radios won't re-render the port code/name fields
      const portDefaults = {
        port_type: null,
        port_code_type: null,
        port_code: null,
        port_name: null,
      };
      this.form = Object.assign({}, portDefaults, this.location);
      this.initiate_location_data = Object.assign({}, portDefaults, this.location);
      if (!this.form.port_code_type) {
        const portCodeType = this.defaultPortCodeType(this.form.port_type);
        if (portCodeType) {
          this.$set(this.form, 'port_code_type', portCodeType);
        }
      }
      if (this.form.published_at) {
        this.published = true;
      }
      // avoid overwriting the saved values while the form is being populated
      this.$nextTick(() => {
        this.portCodeTypeAutoReady = true;
        this.portAutoFillReady = true;
        this.roomsIntegrationTypeSyncReady = true;
      });
      // this.timezones = _.cloneDeep(this.$store.state.timezones.all);
      // this.country = this.form.country_id
      // this.state = this.form.state_id
      if (!Array.isArray(this.form.integration_system_attributes)) {
        this.$set(this.form, 'integration_system_attributes', []);
      }
      if (!Array.isArray(this.form.rooms_integration_system_attributes)) {
        this.$set(this.form, 'rooms_integration_system_attributes', []);
      }
      this.integrationSystemChanged('parking');
      this.integrationSystemChanged('room');
    });
  }
}
